"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unaryMinusDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var unaryMinusDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createUnaryMinus: _factoriesAny.createUnaryMinus
};
exports.unaryMinusDependencies = unaryMinusDependencies;